<template>
    <AffiliationPanel
        @reloadRelations="$emit('reloadRelations')"
        @sendInvites="sendInvites"
        @removeItem="removeItem"
        :name="$lang.get('Members')"
        :parentModel="parentModel"
        :items="members"
        :sentRequests="sentRequests"
        :recievedRequests="recievedRequests"
        :invitesEnabled="true"
        :openModalButtonText="
            canEdit ? $lang.get('Handle members') : $lang.get('Show all')
        "
        :modalTitle="
            canEdit ? $lang.get('Handle members') : $lang.get('Members')
        "
        :canEdit="canEdit"
        :filterTabNames="{
            all: $lang.get('All'),
            approved: $lang.get('Members'),
            sentRequests: $lang.get('Invitations'),
            recievedRequests: $lang.get('Requests'),
        }"
        :approveAffiliationText="$lang.get('Approve membership')"
        :definitiveItemName="$lang.get('the member')"
        :definitiveRecievedName="$lang.get('the request')"
        :definitiveSentName="$lang.get('the invitation')"
        :alreadyConfirmedMsg="
            $lang.get(':Definitive_user is already a member', {
                Definitive_user: this.$getBaseModelTranslation({
                    modelName: 'user',
                    wordClass: 'definitive',
                }),
            })
        "
        :alreadySentMsg="
            $lang.get(':Definitive_user has already been invited', {
                Definitive_user: this.$getBaseModelTranslation({
                    modelName: 'user',
                    wordClass: 'definitive',
                }),
            })
        "
        :alreadyRequestedMsg="
            $lang.get(':Definitive_user has already requested membership', {
                Definitive_user: this.$getBaseModelTranslation({
                    modelName: 'user',
                    wordClass: 'definitive',
                }),
            })
        "
        :noApprovedItemsMsg="$lang.get('No members')"
        :openOnLoad="openOnLoad"
        :activeTab="activeTab"
    />
</template>

<script>
import AffiliationPanel from '@/Components/Panels/AffiliationPanel/AffiliationPanel.vue'
import axios from 'axios'

export default {
    name: 'MemberPanel',

    components: {
        AffiliationPanel,
    },

    emits: ['reloadRelations'],

    props: {
        parentModel: {
            type: Object,
            required: true,
        },
        items: {
            type: Array,
            default: [],
        },
        sentRequests: {
            type: Array,
            default: [],
        },
        recievedRequests: {
            type: Array,
            default: [],
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
        openOnLoad: {
            type: Boolean,
            default: false,
        },
        activeTab: {
            type: String,
            default: null,
        },
    },

    computed: {
        members() {
            return this.items.map((item) => {
                let parent = item.organization
                return {
                    ...item,
                    url: this.$getModelUrl({
                        modelClass: 'user',
                        id: item.id,
                    }),
                    parentUrl: parent
                        ? this.$getModelUrl({
                              modelClass: 'organization',
                              id: parent.id,
                          })
                        : null,
                    parentName: parent ? parent.name : null,
                }
            })
        },
    },

    methods: {
        removeItem(item_id) {
            axios
                .delete(route('api.affiliations.destroy', item_id))
                .then((response) => {
                    this.$emit('reloadRelations')
                })
        },

        sendInvites(usersToInvite) {
            axios
                .post(route('api.pending-approvals.create.membership'), {
                    initiator_id: this.parentModel.id,
                    initiator_class: this.parentModel.modelClass,
                    targets: usersToInvite.map((user_id) => ({
                        id: user_id,
                        model_class: 'user',
                    })),
                })
                .then((response) => {
                    this.$emit('reloadRelations')
                })
        },
    },
}
</script>
